var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.409 12.2472C13.409 15.6973 10.6311 18.4942 7.20461 18.4942C3.7781 18.4942 1 15.6967 1 12.2472C1 8.7977 3.77789 6 7.20461 6C10.6313 6 13.409 8.79707 13.409 12.2472Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2152 12.2476C20.2152 15.4951 18.8263 18.1288 17.1129 18.1288C15.3996 18.1288 14.0106 15.4951 14.0106 12.2476C14.0106 9 15.3994 6.3663 17.1127 6.3663C18.8261 6.3663 20.2152 8.99916 20.2152 12.2476Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 12.2473C22.9997 15.1563 22.5113 17.5159 21.9087 17.5159C21.306 17.5159 20.8178 15.1569 20.8178 12.2473C20.8178 9.33762 21.3062 6.97859 21.9087 6.97859C22.5111 6.97859 22.9997 9.33741 22.9997 12.2473Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.d0b9521afcdebfe999824aca80c0fe05.svg";
export { ForwardRef as ReactComponent };